import React, { useEffect, memo, useReducer, useRef, useState } from 'react'
import { useInterval, useMeasure, useStateList } from 'react-use'

import { useApp } from 'store/AppStore'

import { FrameContainer, Root } from './PngSequencer.styled.js'

import spritesheets from 'assets/spritesheets'

import { Canvas, useFrame, ThreeElements } from '@react-three/fiber'



const PngSequencer = ({ path, selected, visible, frameW, frameH }) => {
  const { loadInc } = useApp()

  const [ref, { width, height }] = useMeasure()

  const pos = new Array(101).fill('').map((_, id) => id)

  const { state, next } = useStateList(pos)

  useInterval(
    () => {
      //next()
    },
    selected && visible ? 1000 / 30 : null
  )

  const containerScale = Math.min(width / frameW, height / frameH)

//pointer event pour éviter le click sur le canvas rootclass pour les effects

if(window.utalk.selprodind >= 8){

  return (
    <Root className="disabledroot" style={{pointerEvents:"none"}} ref={ref}>
      <div className="Inner clicktrought">
        <FrameContainer w={frameW * containerScale} h={frameH * containerScale}>
          <img
            src={spritesheets[path]}
            alt=""
            style={{ transform: `translate(${-state * frameW * containerScale}px,0)` }}
            onLoad={() => loadInc(1)}
          />
        </FrameContainer>
      </div>
    </Root>
  )
}

else{

  return (
    <Root className="enableroot" style={{pointerEvents:"none"}} ref={ref}>
      <div className="Inner clicktrought">
        <FrameContainer w={frameW * containerScale} h={frameH * containerScale}>
          <img
            src={spritesheets[path]}
            alt=""
            style={{ transform: `translate(${-state * frameW * containerScale}px,0)` }}
            onLoad={() => loadInc(1)}
          />
        </FrameContainer>
      </div>
    </Root>
  )
}

}


export default memo(PngSequencer)
